import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  service: [],
  allService: [],
  addServiceData: []
};

export const ServiceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    getServiceAction: (state, action) => {
      state.service = action.payload;
    },
    getAllServiceAction: (state, action) => {
      // 
      state.allService = action.payload;
    },
    getAddServiceDataAction: (state, action) => {
      // 
      state.addServiceData = action.payload;
    }
  },
});

export default ServiceSlice.reducer;

export const { getServiceAction, getAllServiceAction, getAddServiceDataAction } = ServiceSlice.actions;
